import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme) => ({
  styledBreadcrumbContainer: {
    '&> ol': {
      flexWrap: 'nowrap',
    },
  },
  styledBreadcrumbContainerWrap: {
    '&> ol': {
      flexWrap: 'wrap',
    },
  },
  ellipsis: {
    position: 'relative',
    top: '-7px',
    color: colors.gray.l15,
    fontSize: '25px',
    fontWeight: 700,
    cursor: 'pointer',
  },
  hiddenBreadcrumbs: {
    position: 'absolute',
    padding: '0 18px',
  },
  companyName: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down(470)]: {
      whiteSpace: 'normal',
    },
  },
}));
